export enum MethodType {
    None = 0,
    Get = 1,
    Put = 2,
    Post = 4,
    Delete = 8,
    Options = 16,
    Patch = 32
}
